module.exports = __webpack_public_path__ + "img/05-title-02-m.f999d496.png";